/* @flow */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
@inject('projectDetailsStore')
@observer
class CostCenters extends React.Component<*> {
  render(): React.Element<*> {
    const t: Function = this.props.t;
    const { details }: any = this.props;
    return details && details.length > 0 ? (
      <React.Fragment>
        <h3>{t('general:cost_centers.assigned_to_project')}</h3>
        <table className="layout-table large-first-col">
          <tbody>
            <tr>
              <th>{t('general:cost_centers.labels.name')}</th>
              <th>{t('general:cost_centers.labels.code')}</th>
            </tr>
            {typeof details === 'undefined'
              ? null
              : details.map((cc: any) => {
                  return (
                    <tr key={cc.id}>
                      <td>{cc.name}</td>
                      <td className="layout-flex">
                        <div>
                          <span>{cc.code}</span>
                          <Link to={'/cost-centers/' + cc.id} className="layout-button">
                            <Button variant="contained" color="primary">
                              {t('general:actions.view_cost_center')}
                            </Button>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </React.Fragment>
    ) : null;
  }
}

export default CostCenters;
